import axios from "axios";
import setAuthorizationHeaders from "./setAuthorizationHeaders";

// import cookie from "react-cookies";

const {
  REACT_APP_API_GATEWAY,
  REACT_APP_AUTH_USERNAME,
  REACT_APP_AUTH_PASSWORD,
  REACT_APP_DEFAULT_PATH,
} = process.env;

let baseURL = `${REACT_APP_API_GATEWAY}${REACT_APP_DEFAULT_PATH}`;
const origin = window.location.origin;
let sessiontoken = localStorage.getItem("sessionToken");
let headers;

if (origin.includes("localhost")) {
  headers = {
    sessiontoken,
    "x-origin": "api.b3works.com",
    domain: localStorage.getItem("domain"),
    "portal-domain": window.location.hostname,
  };
} else {
  baseURL = `${origin}${REACT_APP_DEFAULT_PATH}`;
  headers = {
    domain: localStorage.getItem("domain"),
    "portal-domain": window.location.host,
  };
}
// document.Cookie = `sessionToken=${sessionToken}; Domain=localhost:3030;`;
const instance = axios.create({
  baseURL,
  headers,
});

if (origin.includes("localhost")) {
  if (setAuthorizationHeaders.length === 0)
    instance.defaults.headers["sessiontoken"] = sessiontoken;
  instance.defaults.headers["domain"] = localStorage.getItem("domain");
}
instance.interceptors.response.use((response) => response.data);
export { setAuthorizationHeaders };
export default instance;
